if (!customElements.get('bt-product-details-tabs')) {
  class ProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new UtenzoTheme.Tabs(this);

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }
  }
  customElements.define('bt-product-details-tabs', ProductDetailsTabs);
}
